import React, { Fragment } from 'react';
import { Radio as AntRadio } from 'antd';

/**
 * A radio button for forms
 *
 * {@link https://ant.design/components/radio#api}
 *
 * @module RadioButton
 * @param {Object} props - the radio button props
 * @param {string} [props.description] - the radio button description displayed
 * @param {boolean} [props.disabled] - whether or not the radio button is disabled
 * @param {string} [props.label] - the radio button label
 * @param {React.ReactElement} - the icon displayed next to the radio button
 * @returns {React.ReactElement} - a radio button
**/
const RadioButton = ( { children, description, disabled, label, icon, ...restProps } ) => {

    const childrenToRender = (
        <Fragment>
            { icon ? (
                <span className='origami-radio-lock-icon'>
                    { icon }
                </span>
            ) : null }

            <span className='origami-radio-button-label'>
                { label ? label : children }
            </span>

            { description ? (
                <span className='origami-radio-button-description'>
                    { description }
                </span>
            ) : null }
        </Fragment>
    );

    return (
        <AntRadio.Button { ...restProps } >
            { childrenToRender }
        </AntRadio.Button>
    );
};

export default RadioButton;
